export default __webpack_public_path__ + "static/media/arrow-left.0951a111.svg";